import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import axios from 'axios';

const DesignAndProjects = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/projets?populate=*`, {
                    headers: {
                        Authorization: `${process.env.REACT_APP_API_TOKEN}`
                    }
                });
                setProjects(response.data.data);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchProjects();
    }, []);

    if (loading) return <div className="h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
  </div>;
    if (error) return <div>Error: {error.message}</div>;

    return (
        <div className="min-h-screen flex flex-col">
            <div className="flex-1">
                <motion.div
                    className="mx-auto p-4 bg-peach-cream"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                >
                    <div className='container'>
                        <motion.header
                            className="text-5xl md:text-7xl lg:text-9xl font-light leading-none font-cormorant mb-14 mt-5 text-[#333333] whitespace-normal break-words"
                            initial={{ y: -50, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.5 }}
                        >
                            <h1 className="text-cocoa-600 break-words">
                                Nos Réalisations
                            </h1>
                            <p className="text-base md:text-lg lg:font-medium lg:text-4xl mt-4 text-cocoa-500">
                                Introduction au service proposé par l'entreprise
                            </p>
                        </motion.header>

                        <div className="w-auto h-1 bg-cocoa my-8 mx-10"></div>

                        <motion.section
                            className="my-8 pb-8" // Ajout de padding-bottom
                            initial={{ x: 50, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ duration: 0.5, delay: 1 }}
                        >
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
                                {projects.map((project) => (
                                    <Link to={`/design-and-projects/${project.documentId}`} key={project.documentId}>
                                        <ProjectCard project={project} />
                                    </Link>
                                ))}
                            </div>
                        </motion.section>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

const ProjectCard = ({ project }) => {
    const { title, type, year, location, description, image } = project;
    const imageUrl = image ? `${image.url}` : 'https://via.placeholder.com/300';
    return (
        <motion.div
            className="bg-white shadow-lg rounded-lg overflow-hidden relative h-80 md:h-96"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
        >
            <img src={imageUrl} alt={title} className="absolute inset-0 w-full h-full object-cover" />
            <div className="relative p-4 bg-opacity-75 bg-black/40 text-white h-full flex flex-col">
                <h3 className="text-lg md:text-xl lg:text-2xl font-bold uppercase">{title}</h3>
                <p className="mt-2 text-sm md:text-base lg:text-lg">{description ? description[0].content : 'No description available.'}</p>
                <button className="mt-4 bg-brandy-rose text-white py-2 px-4 rounded self-end bottom-10 absolute text-xs md:text-sm lg:text-base">Contactez-nous</button>
            </div>
        </motion.div>
    );
};

export default DesignAndProjects;